// extracted by mini-css-extract-plugin
export default {"backdrop":"Backdrop-module_backdrop_QeTsI","fullscreen":"Backdrop-module_fullscreen_biHFZ"};